import get from "lodash/get";

function isActivePath(path, target, exact) {
  if (exact) {
    return target.replace(/\/$/, "") === path;
  }

  if (target) {
    return target.indexOf(path) === 0;
  }

  return false;
}

function getIdFromRouterProps(props) {
  const rawId = get(props, "match.params.id", null);
  return rawId === null ? null : Number(rawId);
}

export { getIdFromRouterProps, isActivePath };
